import React, {ReactElement, useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {GET} from "../../../../Hooks/RequestV2";
import AlphabetFilter from "./Components/AlphabetFilter";
import {useSearch, useSearchCategory} from "../../HeaderMenu";
import {ActiveMenuContext} from "../Header";
import {ChannelContext} from "../../../../Contexts/ChannelContext";
import {UserContext} from "../../../../Contexts/UserContext";
import {useIsOnlySpecialOffers} from "../../Hooks/useIsOnlySpecialOffers";

const emptyFilters = {
    filters: {
        categories: [],
        producers: [],
        brands: [],
        licenses: [],
        logs: {},
        specialOffers: []
    },
    logs: {}
};

const filtersToggleDefaultSate = {
    categories: false,
    producers: false,
    brands: false,
    licenses: false,
    specialOffers: false
};

export interface FiltersToggleStateInterface {
    categories: boolean,
    producers: boolean,
    brands: boolean,
    licenses: boolean,
    specialOffers: boolean
};

interface MobileMenuInterface {
    activeState: {
        activeMenu: boolean,
        setActiveMenu: React.Dispatch<boolean>
    }
}

export default function MobileMenu(): ReactElement {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [filters, setFilters] = useState(emptyFilters);
    const activeState = useContext(ActiveMenuContext);
    const channelContext  = useContext(ChannelContext);
    const userContext = useContext(UserContext);
    const isOnlyOffer: boolean = useIsOnlySpecialOffers();

    const [filtersToggleState, setFiltersToggleState] = useState<FiltersToggleStateInterface>(filtersToggleDefaultSate);

    const searchCategories  = useSearchCategory(filters.filters.categories);
    const searchProducers   = useSearch(filters.filters.producers);
    const searchBrands      = useSearch(filters.filters.brands);
    const searchLicenses    = useSearch(filters.filters.licenses);

    useEffect(() => {
        GET('/filters/menu')
            .then((response) => {
                if (response.ok){
                    response.json().then(setFilters);
                }
            });
    }, []);

    function SpecialOffers(): ReactElement
    {
        return (
            <li style={userContext?.user && filters.filters.hasOwnProperty('specialOffers') ? undefined : {display:"none"}} >
                <AlphabetFilter
                    data={filters.filters.specialOffers}
                    label={t('layout.menu.special-offers')}
                    propertyName={'specialOffers'}
                    search={useSearch(filters.filters.specialOffers)}
                    toggleState={{filtersToggleState, setFiltersToggleState}}
                />
            </li>
        );
    }

    return (
        <nav className={activeState?.activeMenu ? 'active' : undefined} >
            <div className={'wrapper'} >
                <button onClick={() => activeState?.setActiveMenu(false)} className={'close-menu'} >
                    <i className={'fas fa-times'} />
                </button>
                <ul>
                    {!isOnlyOffer ?
                        <>
                            <li>
                                <AlphabetFilter
                                    data={filters.filters.categories}
                                    label={t('layout.menu.categories')}
                                    propertyName={'categories'}
                                    search={searchCategories}
                                    toggleState={{filtersToggleState, setFiltersToggleState}}
                                />
                            </li>
                            <li>
                                <AlphabetFilter
                                    data={filters.filters.producers}
                                    label={t('layout.menu.producers')}
                                    propertyName={'producers'}
                                    search={searchProducers}
                                    toggleState={{filtersToggleState, setFiltersToggleState}}
                                />
                            </li>
                            <li>
                                <AlphabetFilter
                                    data={filters.filters.brands}
                                    label={t('layout.menu.brands')}
                                    propertyName={'brands'}
                                    search={searchBrands}
                                    toggleState={{filtersToggleState, setFiltersToggleState}}
                                />
                            </li>
                            <li>
                                <AlphabetFilter
                                    data={filters.filters.licenses}
                                    label={t('layout.menu.licenses')}
                                    propertyName={'licenses'}
                                    search={searchLicenses}
                                    toggleState={{filtersToggleState, setFiltersToggleState}}
                                />
                            </li>
                            <li>
                                <button onClick={() => {
                                    activeState?.setActiveMenu(false);
                                    navigate('/products-list/news')
                                }} >{t('layout.menu.news')}</button>
                            </li>
                            <li>
                                <button onClick={() => {
                                    activeState?.setActiveMenu(false);
                                    navigate('/products-list/promotions');
                                }} >{t('layout.menu.promotions')}</button>
                            </li>
                            <li>
                                <button onClick={() => {
                                    activeState?.setActiveMenu(false);
                                    navigate('/products-list/sales');
                                }} >{t('layout.menu.sales')}</button>
                            </li>
                        </>

                        : null}

                    {userContext?.user && filters.filters.hasOwnProperty('specialOffers') ?
                        <SpecialOffers />
                        :
                        <>
                            {userContext?.user && isOnlyOffer ?

                                <li>
                                    <button>{t('layout.menu.special-offers')}</button>
                                </li>

                                : null}
                        </>
                    }

                    {channelContext?.partnersOffer && !isOnlyOffer ?
                        <li>
                            <button onClick={() => {
                                activeState?.setActiveMenu(false);
                                window.location.href = userContext?.user ? 'https://partnerzy.euro-trade.pl/index.php?token=t6QklJsbS0FrHzNFsDwhpYctXRhW6F' : 'https://partnerzy.euro-trade.pl/';
                            }} >{t('layout.menu.partners')}</button>
                        </li>
                    : null}
                </ul>
            </div>
        </nav>
    );
}